import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Dialog/DialogUsage.mdx";
import DevGuidance from "../../Docs/Components/Dialog/DialogDevGuidance.mdx";

import Examples from "../../Docs/Components/Dialog/DialogExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Dialog"
            description="A dialog is a temporary, modal overlay that can provide contextual information and/or require user confirmation or input."
            apiSources={["azure-devops-ui/Components/Dialog/Dialog.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            usage={Usage}
            devGuidance={DevGuidance}
        />
    );
}
}
        
export default Page;